// object to store loaded and loading wasm modules
var installedWasmModules = {};

function promiseResolve() { return Promise.resolve(); }

var wasmImportedFuncCache0;
var wasmImportedFuncCache1;
var wasmImportedFuncCache2;
var wasmImportedFuncCache3;
var wasmImportedFuncCache4;
var wasmImportedFuncCache5;
var wasmImportedFuncCache6;
var wasmImportedFuncCache7;
var wasmImportedFuncCache8;
var wasmImportedFuncCache9;
var wasmImportedFuncCache10;
var wasmImportedFuncCache11;
var wasmImportedFuncCache12;
var wasmImportedFuncCache13;
var wasmImportedFuncCache14;
var wasmImportedFuncCache15;
var wasmImportedFuncCache16;
var wasmImportedFuncCache17;
var wasmImportedFuncCache18;
var wasmImportedFuncCache19;
var wasmImportedFuncCache20;
var wasmImportedFuncCache21;
var wasmImportedFuncCache22;
var wasmImportedFuncCache23;
var wasmImportedFuncCache24;
var wasmImportedFuncCache25;
var wasmImportedFuncCache26;
var wasmImportedFuncCache27;
var wasmImportedFuncCache28;
var wasmImportedFuncCache29;
var wasmImportedFuncCache30;
var wasmImportedFuncCache31;
var wasmImportedFuncCache32;
var wasmImportedFuncCache33;
var wasmImportedFuncCache34;
var wasmImportedFuncCache35;
var wasmImportedFuncCache36;
var wasmImportedFuncCache37;
var wasmImportedFuncCache38;
var wasmImportedFuncCache39;
var wasmImportedFuncCache40;
var wasmImportedFuncCache41;
var wasmImportedFuncCache42;
var wasmImportedFuncCache43;
var wasmImportedFuncCache44;
var wasmImportedFuncCache45;
var wasmImportedFuncCache46;
var wasmImportedFuncCache47;
var wasmImportedFuncCache48;
var wasmImportedFuncCache49;
var wasmImportedFuncCache50;
var wasmImportedFuncCache51;
var wasmImportedFuncCache52;
var wasmImportedFuncCache53;
var wasmImportObjects = {
	3976: function() {
		return {
			"./cardano_multiplatform_lib_bg.js": {
				"__wbindgen_object_drop_ref": function(p0i32) {
					if(wasmImportedFuncCache0 === undefined) wasmImportedFuncCache0 = __webpack_require__.c[3363].exports;
					return wasmImportedFuncCache0["bkt"](p0i32);
				},
				"__wbindgen_string_new": function(p0i32,p1i32) {
					if(wasmImportedFuncCache1 === undefined) wasmImportedFuncCache1 = __webpack_require__.c[3363].exports;
					return wasmImportedFuncCache1["ycJ"](p0i32,p1i32);
				},
				"__wbindgen_throw": function(p0i32,p1i32) {
					if(wasmImportedFuncCache2 === undefined) wasmImportedFuncCache2 = __webpack_require__.c[3363].exports;
					return wasmImportedFuncCache2["Qnr"](p0i32,p1i32);
				},
				"__wbindgen_memory": function() {
					if(wasmImportedFuncCache3 === undefined) wasmImportedFuncCache3 = __webpack_require__.c[3363].exports;
					return wasmImportedFuncCache3["Py0"]();
				},
				"__wbindgen_is_object": function(p0i32) {
					if(wasmImportedFuncCache4 === undefined) wasmImportedFuncCache4 = __webpack_require__.c[3363].exports;
					return wasmImportedFuncCache4["qvD"](p0i32);
				},
				"__wbindgen_is_string": function(p0i32) {
					if(wasmImportedFuncCache5 === undefined) wasmImportedFuncCache5 = __webpack_require__.c[3363].exports;
					return wasmImportedFuncCache5["GuA"](p0i32);
				},
				"__wbindgen_is_function": function(p0i32) {
					if(wasmImportedFuncCache6 === undefined) wasmImportedFuncCache6 = __webpack_require__.c[3363].exports;
					return wasmImportedFuncCache6["PRY"](p0i32);
				},
				"__wbindgen_object_clone_ref": function(p0i32) {
					if(wasmImportedFuncCache7 === undefined) wasmImportedFuncCache7 = __webpack_require__.c[3363].exports;
					return wasmImportedFuncCache7["BZb"](p0i32);
				},
				"__wbg_new_1d9a920c6bfc44a8": function() {
					if(wasmImportedFuncCache8 === undefined) wasmImportedFuncCache8 = __webpack_require__.c[3363].exports;
					return wasmImportedFuncCache8["IlD"]();
				},
				"__wbindgen_number_new": function(p0f64) {
					if(wasmImportedFuncCache9 === undefined) wasmImportedFuncCache9 = __webpack_require__.c[3363].exports;
					return wasmImportedFuncCache9["QRK"](p0f64);
				},
				"__wbg_newnoargs_b5b063fc6c2f0376": function(p0i32,p1i32) {
					if(wasmImportedFuncCache10 === undefined) wasmImportedFuncCache10 = __webpack_require__.c[3363].exports;
					return wasmImportedFuncCache10["b3e"](p0i32,p1i32);
				},
				"__wbg_new_268f7b7dd3430798": function() {
					if(wasmImportedFuncCache11 === undefined) wasmImportedFuncCache11 = __webpack_require__.c[3363].exports;
					return wasmImportedFuncCache11["ZrE"]();
				},
				"__wbg_new_0b9bfdd97583284e": function() {
					if(wasmImportedFuncCache12 === undefined) wasmImportedFuncCache12 = __webpack_require__.c[3363].exports;
					return wasmImportedFuncCache12["ZxW"]();
				},
				"__wbg_self_6d479506f72c6a71": function() {
					if(wasmImportedFuncCache13 === undefined) wasmImportedFuncCache13 = __webpack_require__.c[3363].exports;
					return wasmImportedFuncCache13["Rup"]();
				},
				"__wbg_window_f2557cc78490aceb": function() {
					if(wasmImportedFuncCache14 === undefined) wasmImportedFuncCache14 = __webpack_require__.c[3363].exports;
					return wasmImportedFuncCache14["XTH"]();
				},
				"__wbg_globalThis_7f206bda628d5286": function() {
					if(wasmImportedFuncCache15 === undefined) wasmImportedFuncCache15 = __webpack_require__.c[3363].exports;
					return wasmImportedFuncCache15["X5L"]();
				},
				"__wbg_global_ba75c50d1cf384f4": function() {
					if(wasmImportedFuncCache16 === undefined) wasmImportedFuncCache16 = __webpack_require__.c[3363].exports;
					return wasmImportedFuncCache16["MN9"]();
				},
				"__wbindgen_is_undefined": function(p0i32) {
					if(wasmImportedFuncCache17 === undefined) wasmImportedFuncCache17 = __webpack_require__.c[3363].exports;
					return wasmImportedFuncCache17["vUM"](p0i32);
				},
				"__wbg_set_a68214f35c417fa9": function(p0i32,p1i32,p2i32) {
					if(wasmImportedFuncCache18 === undefined) wasmImportedFuncCache18 = __webpack_require__.c[3363].exports;
					return wasmImportedFuncCache18["mLj"](p0i32,p1i32,p2i32);
				},
				"__wbg_call_97ae9d8645dc388b": function(p0i32,p1i32) {
					if(wasmImportedFuncCache19 === undefined) wasmImportedFuncCache19 = __webpack_require__.c[3363].exports;
					return wasmImportedFuncCache19["z4Z"](p0i32,p1i32);
				},
				"__wbg_call_168da88779e35f61": function(p0i32,p1i32,p2i32) {
					if(wasmImportedFuncCache20 === undefined) wasmImportedFuncCache20 = __webpack_require__.c[3363].exports;
					return wasmImportedFuncCache20["SG0"](p0i32,p1i32,p2i32);
				},
				"__wbg_set_933729cf5b66ac11": function(p0i32,p1i32,p2i32) {
					if(wasmImportedFuncCache21 === undefined) wasmImportedFuncCache21 = __webpack_require__.c[3363].exports;
					return wasmImportedFuncCache21["UcU"](p0i32,p1i32,p2i32);
				},
				"__wbg_buffer_3f3d764d4747d564": function(p0i32) {
					if(wasmImportedFuncCache22 === undefined) wasmImportedFuncCache22 = __webpack_require__.c[3363].exports;
					return wasmImportedFuncCache22["P1X"](p0i32);
				},
				"__wbg_new_8c3f0052272a457a": function(p0i32) {
					if(wasmImportedFuncCache23 === undefined) wasmImportedFuncCache23 = __webpack_require__.c[3363].exports;
					return wasmImportedFuncCache23["hwQ"](p0i32);
				},
				"__wbg_newwithlength_f5933855e4f48a19": function(p0i32) {
					if(wasmImportedFuncCache24 === undefined) wasmImportedFuncCache24 = __webpack_require__.c[3363].exports;
					return wasmImportedFuncCache24["pCw"](p0i32);
				},
				"__wbg_subarray_58ad4efbb5bcb886": function(p0i32,p1i32,p2i32) {
					if(wasmImportedFuncCache25 === undefined) wasmImportedFuncCache25 = __webpack_require__.c[3363].exports;
					return wasmImportedFuncCache25["fxE"](p0i32,p1i32,p2i32);
				},
				"__wbg_length_9e1ae1900cb0fbd5": function(p0i32) {
					if(wasmImportedFuncCache26 === undefined) wasmImportedFuncCache26 = __webpack_require__.c[3363].exports;
					return wasmImportedFuncCache26["Eqz"](p0i32);
				},
				"__wbg_set_83db9690f9353e79": function(p0i32,p1i32,p2i32) {
					if(wasmImportedFuncCache27 === undefined) wasmImportedFuncCache27 = __webpack_require__.c[3363].exports;
					return wasmImportedFuncCache27["ZiS"](p0i32,p1i32,p2i32);
				},
				"__wbg_crypto_e1d53a1d73fb10b8": function(p0i32) {
					if(wasmImportedFuncCache28 === undefined) wasmImportedFuncCache28 = __webpack_require__.c[3363].exports;
					return wasmImportedFuncCache28["$G9"](p0i32);
				},
				"__wbg_process_038c26bf42b093f8": function(p0i32) {
					if(wasmImportedFuncCache29 === undefined) wasmImportedFuncCache29 = __webpack_require__.c[3363].exports;
					return wasmImportedFuncCache29["q6z"](p0i32);
				},
				"__wbg_versions_ab37218d2f0b24a8": function(p0i32) {
					if(wasmImportedFuncCache30 === undefined) wasmImportedFuncCache30 = __webpack_require__.c[3363].exports;
					return wasmImportedFuncCache30["nG9"](p0i32);
				},
				"__wbg_node_080f4b19d15bc1fe": function(p0i32) {
					if(wasmImportedFuncCache31 === undefined) wasmImportedFuncCache31 = __webpack_require__.c[3363].exports;
					return wasmImportedFuncCache31["ypP"](p0i32);
				},
				"__wbg_require_78a3dcfbdba9cbce": function() {
					if(wasmImportedFuncCache32 === undefined) wasmImportedFuncCache32 = __webpack_require__.c[3363].exports;
					return wasmImportedFuncCache32["bO0"]();
				},
				"__wbg_msCrypto_6e7d3e1f92610cbb": function(p0i32) {
					if(wasmImportedFuncCache33 === undefined) wasmImportedFuncCache33 = __webpack_require__.c[3363].exports;
					return wasmImportedFuncCache33["MLr"](p0i32);
				},
				"__wbg_randomFillSync_6894564c2c334c42": function(p0i32,p1i32,p2i32) {
					if(wasmImportedFuncCache34 === undefined) wasmImportedFuncCache34 = __webpack_require__.c[3363].exports;
					return wasmImportedFuncCache34["teh"](p0i32,p1i32,p2i32);
				},
				"__wbg_getRandomValues_805f1c3d65988a5a": function(p0i32,p1i32) {
					if(wasmImportedFuncCache35 === undefined) wasmImportedFuncCache35 = __webpack_require__.c[3363].exports;
					return wasmImportedFuncCache35["zM6"](p0i32,p1i32);
				},
				"__wbg_String_91fba7ded13ba54c": function(p0i32,p1i32) {
					if(wasmImportedFuncCache36 === undefined) wasmImportedFuncCache36 = __webpack_require__.c[3363].exports;
					return wasmImportedFuncCache36["qB4"](p0i32,p1i32);
				},
				"__wbindgen_error_new": function(p0i32,p1i32) {
					if(wasmImportedFuncCache37 === undefined) wasmImportedFuncCache37 = __webpack_require__.c[3363].exports;
					return wasmImportedFuncCache37["RjG"](p0i32,p1i32);
				},
				"__wbindgen_bigint_from_i64": function(p0i64) {
					if(wasmImportedFuncCache38 === undefined) wasmImportedFuncCache38 = __webpack_require__.c[3363].exports;
					return wasmImportedFuncCache38["ce0"](p0i64);
				},
				"__wbindgen_bigint_from_u64": function(p0i64) {
					if(wasmImportedFuncCache39 === undefined) wasmImportedFuncCache39 = __webpack_require__.c[3363].exports;
					return wasmImportedFuncCache39["Qg3"](p0i64);
				},
				"__wbg_set_20cbc34131e76824": function(p0i32,p1i32,p2i32) {
					if(wasmImportedFuncCache40 === undefined) wasmImportedFuncCache40 = __webpack_require__.c[3363].exports;
					return wasmImportedFuncCache40["H0I"](p0i32,p1i32,p2i32);
				}
			}
		};
	},
	5605: function() {
		return {
			"./cardano_message_signing_bg.js": {
				"__wbindgen_object_drop_ref": function(p0i32) {
					if(wasmImportedFuncCache41 === undefined) wasmImportedFuncCache41 = __webpack_require__.c[2845].exports;
					return wasmImportedFuncCache41["bk"](p0i32);
				},
				"__wbindgen_string_new": function(p0i32,p1i32) {
					if(wasmImportedFuncCache42 === undefined) wasmImportedFuncCache42 = __webpack_require__.c[2845].exports;
					return wasmImportedFuncCache42["yc"](p0i32,p1i32);
				},
				"__wbindgen_debug_string": function(p0i32,p1i32) {
					if(wasmImportedFuncCache43 === undefined) wasmImportedFuncCache43 = __webpack_require__.c[2845].exports;
					return wasmImportedFuncCache43["rl"](p0i32,p1i32);
				},
				"__wbindgen_throw": function(p0i32,p1i32) {
					if(wasmImportedFuncCache44 === undefined) wasmImportedFuncCache44 = __webpack_require__.c[2845].exports;
					return wasmImportedFuncCache44["Qn"](p0i32,p1i32);
				}
			}
		};
	},
	415: function() {
		return {
			"./uplc_wrapper_bg.js": {
				"__wbindgen_object_drop_ref": function(p0i32) {
					if(wasmImportedFuncCache45 === undefined) wasmImportedFuncCache45 = __webpack_require__.c[4124].exports;
					return wasmImportedFuncCache45["bk"](p0i32);
				},
				"__wbindgen_string_new": function(p0i32,p1i32) {
					if(wasmImportedFuncCache46 === undefined) wasmImportedFuncCache46 = __webpack_require__.c[4124].exports;
					return wasmImportedFuncCache46["yc"](p0i32,p1i32);
				},
				"__wbindgen_memory": function() {
					if(wasmImportedFuncCache47 === undefined) wasmImportedFuncCache47 = __webpack_require__.c[4124].exports;
					return wasmImportedFuncCache47["Py"]();
				},
				"__wbg_buffer_a448f833075b71ba": function(p0i32) {
					if(wasmImportedFuncCache48 === undefined) wasmImportedFuncCache48 = __webpack_require__.c[4124].exports;
					return wasmImportedFuncCache48["x0"](p0i32);
				},
				"__wbg_newwithbyteoffsetandlength_d0482f893617af71": function(p0i32,p1i32,p2i32) {
					if(wasmImportedFuncCache49 === undefined) wasmImportedFuncCache49 = __webpack_require__.c[4124].exports;
					return wasmImportedFuncCache49["qw"](p0i32,p1i32,p2i32);
				},
				"__wbg_new_8f67e318f15d7254": function(p0i32) {
					if(wasmImportedFuncCache50 === undefined) wasmImportedFuncCache50 = __webpack_require__.c[4124].exports;
					return wasmImportedFuncCache50["BL"](p0i32);
				},
				"__wbg_length_1d25fa9e4ac21ce7": function(p0i32) {
					if(wasmImportedFuncCache51 === undefined) wasmImportedFuncCache51 = __webpack_require__.c[4124].exports;
					return wasmImportedFuncCache51["IF"](p0i32);
				},
				"__wbg_set_2357bf09366ee480": function(p0i32,p1i32,p2i32) {
					if(wasmImportedFuncCache52 === undefined) wasmImportedFuncCache52 = __webpack_require__.c[4124].exports;
					return wasmImportedFuncCache52["mS"](p0i32,p1i32,p2i32);
				},
				"__wbindgen_throw": function(p0i32,p1i32) {
					if(wasmImportedFuncCache53 === undefined) wasmImportedFuncCache53 = __webpack_require__.c[4124].exports;
					return wasmImportedFuncCache53["Qn"](p0i32,p1i32);
				}
			}
		};
	},
};

var wasmModuleMap = {
	"2288": [
		415
	],
	"3254": [
		5605
	],
	"8305": [
		3976
	]
};

// object with all WebAssembly.instance exports
__webpack_require__.w = {};

// Fetch + compile chunk loading for webassembly
__webpack_require__.f.wasm = function(chunkId, promises) {

	var wasmModules = wasmModuleMap[chunkId] || [];

	wasmModules.forEach(function(wasmModuleId, idx) {
		var installedWasmModuleData = installedWasmModules[wasmModuleId];

		// a Promise means "currently loading" or "already loaded".
		if(installedWasmModuleData)
			promises.push(installedWasmModuleData);
		else {
			var importObject = wasmImportObjects[wasmModuleId]();
			var req = fetch(__webpack_require__.p + "" + {"2288":{"415":"f2d9f27c1e12c6b7e045"},"3254":{"5605":"ef5de59277d0fbecfa69"},"8305":{"3976":"a84549913a2f44e12e23"}}[chunkId][wasmModuleId] + ".module.wasm");
			var promise;
			if(importObject && typeof importObject.then === 'function' && typeof WebAssembly.compileStreaming === 'function') {
				promise = Promise.all([WebAssembly.compileStreaming(req), importObject]).then(function(items) {
					return WebAssembly.instantiate(items[0], items[1]);
				});
			} else if(typeof WebAssembly.instantiateStreaming === 'function') {
				promise = WebAssembly.instantiateStreaming(req, importObject);
			} else {
				var bytesPromise = req.then(function(x) { return x.arrayBuffer(); });
				promise = bytesPromise.then(function(bytes) {
					return WebAssembly.instantiate(bytes, importObject);
				});
			}
			promises.push(installedWasmModules[wasmModuleId] = promise.then(function(res) {
				return __webpack_require__.w[wasmModuleId] = (res.instance || res).exports;
			}));
		}
	});
};